function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M17 5H15C15 4.7 15 4.5 14.9 4.3C14.6 2.9 13.4 2 12 2C10.6 2 9.4 2.9 9.1 4.2C9 4.5 9 4.7 9 5H7C7 4.5 7.1 4.1 7.2 3.7C7.7 1.5 9.7 0 12 0C14.3 0 16.3 1.5 16.8 3.8C16.9 4.1 17 4.5 17 5ZM12 16C9.2 16 7 13.8 7 11H9C9 12.7 10.3 14 12 14C13.7 14 15 12.7 15 11H17C17 13.8 14.8 16 12 16Z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M9 5H7C7 4.5 7.1 4.1 7.2 3.7L9.1 4.2C9 4.5 9 4.7 9 5ZM12 20C7 20 3 16 3 11C3 10.4 3.4 10 4 10C4.6 10 5 10.4 5 11C5 14.9 8.1 18 12 18C15.9 18 19 14.9 19 11C19 10.4 19.4 10 20 10C20.6 10 21 10.4 21 11C21 16 17 20 12 20ZM16 24H8C7.4 24 7 23.6 7 23C7 22.4 7.4 22 8 22H16C16.6 22 17 22.4 17 23C17 23.6 16.6 24 16 24Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M12 24C11.4 24 11 23.6 11 23V19C11 18.4 11.4 18 12 18C12.6 18 13 18.4 13 19V23C13 23.6 12.6 24 12 24ZM8 12C7.4 12 7 11.6 7 11V5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5V11C9 11.6 8.6 12 8 12ZM16 12C15.4 12 15 11.6 15 11V5C15 4.4 15.4 4 16 4C16.6 4 17 4.4 17 5V11C17 11.6 16.6 12 16 12Z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};
export default __webpack_public_path__ + "static/media/mic.d0a9c6e1.svg";
export { SvgComponent as ReactComponent };